import styled from "@emotion/styled";
import { fontMerriweather, fontRobotoCondensed } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const Container = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  color: #000000;
`;

export const Section = styled.div`
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
`;

export const Headline = styled.div`
  font-weight: 400;
  font-size: 15px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: 21px;
`;

export const ActionBar = styled.div`
  position: relative;

  padding-inline-end: 9.4px;

  &::after {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-end: 0;
    content: "|";

    color: #999999;

    transform: translateY(-50%);
  }

  time {
    color: #999999;
    font-size: 14px;
    font-family: ${fontRobotoCondensed};
  }
`;

export const ActionBarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;

  margin-block-end: 8px;
`;
